module.exports = __webpack_public_path__ + "assets/99461acc5372079d175e63391a5436b1.mp3";